__webpack_require__.p = "/clipboard/";